import CardMembershipIcon from "@mui/icons-material/CardMembership";
import CompanyList from "./List";
import CompanyEdit from "./Edit";
import CompanyShow from "./Show";
//params
import { SUBSCRIPTION_COMPANY } from "../../../../utils/constants";
//permissions

export const resources = {
  isMenu: true,
  icon: <CardMembershipIcon />,
  name: SUBSCRIPTION_COMPANY,
  title: "Кампании",
  list: <CompanyList />,
  edit: <CompanyEdit />,
  show: <CompanyShow />,
  permission: "editions",
};

//api url
